import * as requestFromServer from './boxesCrud';
import { boxesSlice, callTypes } from './boxesSlice';

const { actions } = boxesSlice;

export const fetchBoxes = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .findBoxes(queryParams)
    .then((response) => {
      switch (response.data.type) {
        case 'SUCCESS':
        case 'SUCCESS_WITH_WARNING':
        case 'SUCCESS_WITH_INFO':
          console.log(response.data.data);
          const { totalCount, entities } = {
            totalCount: response.data.data.totalCount,
            entities: response.data.data.list,
          };
          dispatch(actions.boxesFetched({ totalCount, entities }));
          break;
        default:
          var error = response.data.msg.desc;
          dispatch(actions.catchError({ error, callType: callTypes.list }));
          break;
      }
    })
    .catch((error) => {
      error.clientMessage = "Can't find boxes";
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchBox = (boxCode) => (dispatch) => {
  if (!boxCode) {
    return dispatch(actions.boxFetched({ boxForView: undefined }));
  }

  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getBox(boxCode)
    .then((response) => {
      console.log(response.data);
      switch (response.data.type) {
        case 'SUCCESS':
        case 'SUCCESS_WITH_WARNING':
        case 'SUCCESS_WITH_INFO':
          dispatch(actions.boxFetched({ boxForView: response.data.data }));
          break;
        default:
          var err = response.data.msg;
          dispatch(actions.catchError({ err, callType: callTypes.action }));
          break;
      }
    })
    .catch((error) => {
      error.clientMessage = "Can't find box";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const updateBox = (boxForView) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateBox(boxForView)
    .then((response) => {
      switch (response.data.type) {
        case 'SUCCESS':
        case 'SUCCESS_WITH_WARNING':
        case 'SUCCESS_WITH_INFO':
          dispatch(actions.boxUpdated({ boxForView: response.data.data }));
          dispatch(
            actions.sendMsg({
              msg: 'Амжилттай хадгаллаа!',
              callType: callTypes.action,
            })
          );
          break;
        default:
          var error = response.data.msg.desc;
          dispatch(actions.catchError({ error, callType: callTypes.action }));
          break;
      }
    })
    .catch((error) => {
      error.clientMessage = "Can't update box";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};
